export default "__VITE_ASSET__uvrX7_li__"